import React from 'react';
import { CheckCard } from '@ant-design/pro-components';
import { Flex, Typography,Avatar } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';

const {  Link } = Typography;
const Mcplis = () => (

  <>
    <Link href="/docs/spec/proximity-cn">{window.location.href}</Link>


    <Flex gap={24} vertical>
      <CheckCard.Group

        onChange={(value) => {
          console.log('value', value);
        }}
      >
        
         <CheckCard
          avatar={
            <Avatar
              src="https://gw.alipayobjects.com/zos/bmw-prod/f601048d-61c2-44d0-bf57-ca1afe7fd92e.svg"
              size="large"
            />
          }
           title={ 
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <AppstoreOutlined />
              <span style={{ marginInlineEnd: 8, marginInlineStart: 8 }}>示例</span>
            </div> 
          }
          description="选择一个由流程编排提供的典型用户案例，可以从中学习到流程编排很多设计理念"
          value="A"
        />

        
        
        <CheckCard
        avatar="https://gw.alipayobjects.com/zos/bmw-prod/f601048d-61c2-44d0-bf57-ca1afe7fd92e.svg"
           title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <AppstoreOutlined />
              <span style={{ marginInlineEnd: 8, marginInlineStart: 8 }}>示例</span>
            </div>
          }
          description="选择一个由流程编排提供的典型用户案例，可以从中学习到流程编排很多设计理念"
          value="B"
        />
        <CheckCard
        avatar="https://gw.alipayobjects.com/zos/bmw-prod/f601048d-61c2-44d0-bf57-ca1afe7fd92e.svg"
          title="Card"
          description="选择一个由流程编排提供的典型用户案例，可以从中学习到流程编排很多设计理念"
          value="c"
        />
       


      </CheckCard.Group>

      
    </Flex>


  </>


);
export default Mcplis